import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createFamilyFestPickupAssignment = (request) => {
    return vdkEmHappinessPortalApi.post(`/family-fest/pickup-locations/${request.pickupLocationId}/attendee-assignments`, request);
};
const updateFamilyFestPickupAssignment = (request) => {
    return vdkEmHappinessPortalApi.put(`/family-fest/attendee-assignments/${request.id}`, request);
};
const getAllFamilyFestPickupAssignments = (request) => {
    return vdkEmHappinessPortalApi.post(`/family-fest/attendee-assignments/get-all`, request);
};
const getAssignedFamilyFestAttendeesByPickupLocationId = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/attendee-assignments/get-all-assigned-attendee', request);
};
const getUnassignedFamilyFestAttendeesByPickupLocationId = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/attendee-assignments/get-all-unassigned-attendee', request);
};
const getFamilyFestAttendeesByPickupLocationId = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/attendee-assignments/get-all-attendees', request);
};
const getFamilyFestPickupAssignmentById = (id) => {
    return vdkEmHappinessPortalApi.get(`/family-fest/attendee-assignments/${id}`);
};
const deleteFamilyFestPickupAssignment = (id) => {
    return vdkEmHappinessPortalApi.delete(`/family-fest/attendee-assignments/${id}`);
};
const unassignFamilyFestAttendeeFromRouteVehicle = (assignmentIds) => {
    return vdkEmHappinessPortalApi.patch(`/family-fest/attendee-assignments/unassign-from-route-vehicle`, { assignmentIds });
};
const unassignFamilyFestAttendeeFromVehicle = (attendeeIds) => {
    return vdkEmHappinessPortalApi.patch(`/family-fest/attendee-assignments/unassign`, { attendeeIds });
};
const assignFamilyFestAttendeeToVehicle = (attendeeIds, vehicleId) => {
    return vdkEmHappinessPortalApi.patch(`/family-fest/attendee-assignments/assign`, { attendeeIds, vehicleId });
};
const getFamilyFestAttendeesByVehicleId = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/attendee-assignments/get-all-by-vehicle', request);
};
const getUnassignedFamilyFestAttendeesByEventId = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/attendee-assignments/get-unassigned-attendee-by-event-Id', request);
};
const getAssignedFamilyFestAttendeesByEventId = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/attendee-assignments/get-assigned-attendees-by-event-id', request);
};
const reassignFamilyFestAttendeesToPickupLocation = (request) => {
    return vdkEmHappinessPortalApi.patch('/family-fest/attendee-assignments/reassign-to-pickup-location', request);
};
const assignFamilyFestAttendeeCountToVehicle = (request) => {
    return vdkEmHappinessPortalApi.patch('/family-fest/attendee-assignments/assign-count', request);
};
const autoAssignFamilyFestAttendeesToPickupLocation = (pickupLocationId) => {
    return vdkEmHappinessPortalApi.post(`/family-fest/attendee-assignments/pickup-locations/${pickupLocationId}/auto-assign`, {});
};
const familyFestPickupAssignmentAPI = {
    unassignFamilyFestAttendeeFromRouteVehicle,
    createFamilyFestPickupAssignment,
    updateFamilyFestPickupAssignment,
    getAllFamilyFestPickupAssignments,
    getAssignedFamilyFestAttendeesByPickupLocationId,
    getUnassignedFamilyFestAttendeesByPickupLocationId,
    getFamilyFestAttendeesByPickupLocationId,
    getFamilyFestPickupAssignmentById,
    deleteFamilyFestPickupAssignment,
    unassignFamilyFestAttendeeFromVehicle,
    assignFamilyFestAttendeeToVehicle,
    getFamilyFestAttendeesByVehicleId,
    getUnassignedFamilyFestAttendeesByEventId,
    getAssignedFamilyFestAttendeesByEventId,
    reassignFamilyFestAttendeesToPickupLocation,
    assignFamilyFestAttendeeCountToVehicle,
    autoAssignFamilyFestAttendeesToPickupLocation
};
export default familyFestPickupAssignmentAPI;
